var authStateKey = 'authState';
var authStates;
(function (authStates) {
  authStates["authorized"] = "authorized";
  authStates["unauthorized"] = "unauthorized";
})(authStates || (authStates = {}));

export { authStateKey, authStates };
//# sourceMappingURL=index.js.map
